import api from '../store/apiClient';

/**
 * Authenticated storefront orders (same contract as maison `orderService`).
 * @param {Record<string, unknown>} orderData
 */
export async function createOrder(orderData) {
  const { data } = await api.post('/orders', orderData);
  const body = data ?? {};
  return body.data ?? body;
}
